
/* injects from baggage-loader */


import chromaPointerTpl from './gameplay-input-radio.html';
import ChromaPointerController from './gameplay-input-radio.controller';

export default class ChromaPointerComponent {
    constructor() {
        this.templateUrl = chromaPointerTpl;
        this.controller = ChromaPointerController;
        this.require = {
            ngModelCtrl: "ngModel"
        }
        this.bindings = {
            name: '@',
            image: "=",
            text: "=",
            ngModel: "=",
            value: "=",
            isRequired: "="
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/gameplay-input-radio/gameplay-input-radio.component.js